export { default } from "./FullWidthSplitImages";
export * from "./FullWidthSplitImages";
